export const companyBenchmarksEndpoints = {
    base: "/api/company/benchmarks",
    byId: (jobId: string): string => `/api/company/benchmarks/${jobId}`,
} as const;

export const companyBenchmarksQueryParams = {
    industry: "industry",
    jobTitle: "job_title",
    perPage: "per_page",
} as const;
